export default () => {
  // const ajaxUrl = '/wp-admin/admin-ajax.php';
  const $loadMoreBtn = $('#load-more');
  const $teaser = $('.teaser');
  const teaserLength = $teaser.length;

  let visible = 3;
  $teaser.slice(visible).hide();

  $loadMoreBtn.on('click', (e) => {
    visible += 3;
    $teaser.slice(0, visible).fadeIn();

    if (visible >= teaserLength) {
      $loadMoreBtn.hide();
    }
  });
};
